import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import ResultsUnits from './ResultsUnits';
import agm from '../../services/agm';
import Alerts from '../../utils/alerts';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    Card,
    CardContent
} from '@material-ui/core';

import { BsBuilding } from "react-icons/bs";
import Add from '@material-ui/icons/AddCircleOutline';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        minWidth: 950,
        maxWidth: 950
    },
    container: {
        maxHeight: 495,
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const unitsResultColumns = [
    { name: 'Centro de Custo', field: 'item.unidade.codigo', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Nome', field: 'item.unidade.nome', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Tipo', field: '(item.unidade.tipo) ? item.unidade.tipo.nome : "Não Informado"', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Município', field: '(item.unidade.municipio) ? item.unidade.municipio.nome : ""', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'UF', field: '(item.unidade.municipio) ? item.unidade.municipio.uf : ""', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Gerenciadora', field: '(item.unidade.gerenciadora) ? item.unidade.gerenciadora.nome : ""', size: -1, sortable: 0, exportable: 0, wrap: 0 },
    { name: 'Posição no Mapa', field: '(item.unidade.latitude || item.unidade.longitude) ? ("(" + item.unidade.latitude + ", " + item.unidade.longitude + ")") : "(0,0)"', size: -1, sortable: 0, exportable: 0, wrap: 0 }
];

const unitEmptyMessage = 'Nenhuma Unidade Incluída no Contrato de Manutenção.';

const unitFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: unitEmptyMessage,
    columns: unitsResultColumns
};

const unitCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: unitEmptyMessage,
    columns: unitsResultColumns
};

const unitResultModes = [unitFullMode, unitCompactMode];

const Contract = ({ item, open, closeEdition, updateValues, dependencies, selectedMode, vision }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [unit, setUnit] = useState();

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const requestUnitCode = async (value, values) => {
        values.code = value;
        await agm.get('/unidades/' + value, {}, {}).then((response) => {
            if (!response.data.error) {
                var units = response.data;
                if (units.length > 0) {
                    if (units[0].ativa) {
                        setUnit(units[0]);
                        values.unitName = units[0].nome;
                    } else {
                        setUnit(null);
                        setMessage({
                            error: true,
                            warn: true,
                            message: "Unidade está inativa.",
                            detail: "Unidade " + value + ' - ' + units[0].nome + " existe mas está inativa. Acesse tela de unidades e ative a unidade."
                        });
                        setOpenAlert(true);
                    }
                } else {
                    values.unitName = '';
                    values.code = '';
                    setMessage({
                        error: true,
                        message: "Unidade Centro de Custo " + value + " não foi encontrada.",
                        detail: "Tente novamente.",
                    });
                    setOpenAlert(true);
                }
            } else {
                values.unitName = '';
                values.code = '';
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            values.unitName = '';
            values.code = '';
            console.debug(error);
        })
    }

    const handleAddItem = async (values) => {
        values.unitName = '';
        values.code = '';
    }

    const removeItem = () => {

    }

    return (
        <Fragment>


            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Contrato de Manutenção
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                numero: Yup.string().max(20).required('O número do cotrato é obrigatório'),
                                nome: Yup.string().required('O nome do contrato é obrigatório'),
                                EMPRESA: Yup.string().required('O cliente do contrato é obrigatória'),
                                dataCriacao: Yup.string().required('A Data de Criação é obrigatória'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <br></br>
                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >
                                    <Grid
                                        item
                                        md={2}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.numero && errors.numero)}
                                            fullWidth
                                            required
                                            label="Número"
                                            margin="none"
                                            name="numero"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.numero}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={5}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.nome && errors.nome)}
                                            fullWidth
                                            required
                                            label="Nome"
                                            margin="none"
                                            name="nome"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.nome}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={5}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth margin="none">
                                            <InputLabel shrink htmlFor="EMPRESA" required >Cliente</InputLabel>
                                            <Select notched
                                                autosize={true}
                                                required
                                                readOnly
                                                error={Boolean(touched.EMPRESA && errors.EMPRESA)}
                                                helperText={touched.EMPRESA && errors.EMPRESA}
                                                value={values.EMPRESA}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Cliente"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'EMPRESA',
                                                    id: 'EMPRESA',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>
                                                {dependencies.companies.map((empresa) => (
                                                    <MenuItem key={empresa.id} value={empresa.id}>{empresa.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={2}
                                        xs={12}>

                                        <KeyboardDatePicker
                                            fullWidth
                                            required
                                            cancelLabel="Cancelar"
                                            margin="none"
                                            inputVariant="outlined"
                                            id="dataCriacao"
                                            label="Data de Criação"
                                            format="DD/MM/YYYY"
                                            name="dataCriacao"
                                            value={values.dataCriacao}
                                            onBlur={handleBlur}
                                            onChange={value => setFieldValue("dataCriacao", value)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={2}
                                        xs={12}>

                                        <KeyboardDatePicker
                                            fullWidth
                                            cancelLabel="Cancelar"
                                            margin="none"
                                            inputVariant="outlined"
                                            id="dataEncerramento"
                                            label="Data de Encerremento"
                                            format="DD/MM/YYYY"
                                            name="dataEncerramento"
                                            value={values.dataEncerramento}
                                            onBlur={handleBlur}
                                            onChange={value => setFieldValue("dataEncerramento", value)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={8}
                                        xs={12}
                                    >
                                        <TextField
                                            error={Boolean(touched.descricao && errors.descricao)}
                                            fullWidth
                                            label="Descrição do Contrato"
                                            rows={1}
                                            size={10}
                                            length={512}
                                            multiline
                                            margin="none"
                                            name="descricao"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.descricao}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <Card>
                                            <CardContent>

                                                <Grid container
                                                    direction="row"
                                                    justify="flex-start"
                                                    alignItems="center"
                                                    spacing={1}  >

                                                    <Grid item
                                                        md={12}
                                                        xs={12}>

                                                        <ResultsUnits
                                                            resultset={{
                                                                loaded: true,
                                                                records: dependencies.units.length,
                                                                pages: 1,
                                                                page: 1,
                                                                count: dependencies.units.length,
                                                                rows: dependencies.units
                                                            }}
                                                            resultModes={unitResultModes}
                                                            icon={BsBuilding}
                                                            vision={{}}
                                                            selectedMode={selectedMode}
                                                            openEdition={() => { }}
                                                            openDeletion={(itemdesp) => {
                                                                removeItem(itemdesp, values);
                                                            }}
                                                            openTreatment={() => { }}
                                                            openExportDialog={false}
                                                            values={values}
                                                        />

                                                    </Grid>

                                                </Grid>

                                            </CardContent>
                                        </Card>
                                    </Grid>

                                </Grid>

                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Contract;
